export enum Medium {
  AIR = 'AIR',
  WATER = 'WATER'
}
